/* PDP delivery estimator — talks to the Clinks rates engine (/estimate).
   AU only. Postcode field is always inline-editable: saved choice >
   Cloudflare geo-detection > empty field. Includes an invalid-postcode
   error state and a static international-estimates panel. */
(function () {
  var el = document.querySelector('[data-delivery-estimator]');
  if (!el) return;

  var endpoint = el.getAttribute('data-endpoint');
  var grams = el.getAttribute('data-grams') || '500';
  var price = el.getAttribute('data-price') || '0';
  var variant = el.getAttribute('data-variant') || '';
  var country = (el.getAttribute('data-country') || 'AU').toUpperCase();
  var countryName = el.getAttribute('data-country-name') || country;
  var currency = (el.getAttribute('data-currency') || 'USD').toUpperCase();
  var STORE_KEY = 'clinks_postcode';
  var current = null;

  var CUR_SYM = { USD: '$', AUD: '$', NZD: '$', SGD: '$', CAD: '$', GBP: '£', EUR: '€', AED: 'AED ' };

  /* Translated strings (injected by snippets/clinks-i18n.liquid); the inline
     English below is the fallback when the snippet is absent. */
  var I18N = (window.clinksI18n && window.clinksI18n.estimator) || {};
  function T(key, fallback) { return I18N[key] || fallback; }
  function TR(key, fallback, tokens) {
    var s = T(key, fallback);
    for (var k in tokens) s = s.split('[' + k + ']').join(tokens[k]);
    return s;
  }

  var ICONS = {
    standard: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="14" height="11" rx="1"/><path d="M15 10h4l3 3v4h-7"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>',
    express: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    startrack: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.1 8.3 22 9.3 17 14.1 18.2 21 12 17.8 5.8 21 7 14.1 2 9.3 8.9 8.3 12 2"/></svg>',
  };

  /* Country sites — international shoppers are pushed to their local store,
     where pricing has duties & taxes built in. Countries without a live site
     go to the international store (clinks.co). When a new domain launches,
     flip its `live` flag and it starts receiving its countries. */
  var SITES = {
    AU: { host: 'clinks.com.au', url: 'https://www.clinks.com.au', label: 'clinks.com.au', cur: 'AUD', live: true },
    US: { host: 'clinks.com', url: 'https://www.clinks.com', label: 'clinks.com', cur: 'USD', live: true },
    GB: { host: 'clinks.co.uk', url: 'https://www.clinks.co.uk', label: 'clinks.co.uk', cur: 'GBP', live: true },
    NZ: { host: 'clinks.nz', url: 'https://www.clinks.nz', label: 'clinks.nz', cur: 'NZD', live: true },
    SG: { host: 'clinks.sg', url: 'https://www.clinks.sg', label: 'clinks.sg', cur: 'SGD', live: true },
    DE: { host: 'clinks.de', url: 'https://www.clinks.de', label: 'clinks.de', cur: 'EUR', live: true },
    AE: { host: 'clinks.ae', url: 'https://www.clinks.ae', label: 'clinks.ae', cur: 'AED', live: true },
    ES: { host: 'clinks.es', url: 'https://www.clinks.es', label: 'clinks.es', cur: 'EUR', live: true },
    FR: { host: 'clinks.fr', url: 'https://www.clinks.fr', label: 'clinks.fr', cur: 'EUR', live: true },
    IT: { host: 'clinks.it', url: 'https://www.clinks.it', label: 'clinks.it', cur: 'EUR', live: true },
  };
  var ROW_SITE = { host: 'clinks.co', url: 'https://clinks.co', label: 'clinks.co', cur: 'your currency', live: true };

  function siteFor(cc) {
    var s = SITES[cc];
    return s && s.live ? s : ROW_SITE;
  }

  /* Dropdown for the AU site's international panel. The panel serves GIFTING
     too (shopper in AU, parcel to NL) — so the list must cover every
     destination, not just markets with their own domain. The featured
     entries sit on top; the rest are generated from ALL_CODES with
     names localized to the page language via Intl.DisplayNames (verified:
     ?country=<cc> sticks on clinks.co for any RoW-market country, so a
     declared destination always survives Shopify's geo redirection). */
  var INTL_COUNTRIES = [
    ['US', 'United States'],
    ['GB', 'United Kingdom'],
    ['NZ', 'New Zealand'],
    ['CA', 'Canada'],
    ['AE', 'United Arab Emirates'],
    ['FR', 'France'],
    ['ES', 'Spain'],
    ['IT', 'Italy'],
    ['DE', 'Germany'],
    ['SG', 'Singapore'],
  ];

  var ALL_CODES = ('AF AL DZ AD AO AG AR AM AW AT AZ BS BH BD BB BE BZ BJ BM BT BO BA BW BR BN BG BF BI KH CM CV KY CL CN CO CR HR CW CY CZ DK DJ DM DO EC EG SV EE SZ ET FJ FI GF PF GA GM GE GH GI GR GL GD GP GU GT GG GN GY HT HN HK HU IS IN ID IQ IE IM IL JM JP JE JO KZ KE KI KW KG LA LV LB LS LR LI LT LU MO MG MW MY MV ML MT MH MQ MR MU YT MX FM MD MC MN ME MS MA MZ MM NA NR NP NL NC NI NE NG NU MK MP NO OM PK PW PA PG PY PE PH PL PT PR QA RE RO RW WS SM SA SN RS SC SL SX SK SI SB ZA KR LK KN LC VC SR SE CH TW TJ TZ TH TL TG TO TT TN TR TM TC TV UG UA UY UZ VU VA VE VN VG VI YE ZM ZW').split(' ');

  function restOfWorldOptions() {
    if (!(window.Intl && Intl.DisplayNames)) return null; // ancient browser
    var lang = (document.documentElement.lang || 'en').split('-')[0];
    var dn;
    try { dn = new Intl.DisplayNames([lang], { type: 'region' }); } catch (e) { return null; }
    var featured = {};
    for (var i = 0; i < INTL_COUNTRIES.length; i++) featured[INTL_COUNTRIES[i][0]] = 1;
    var rows = [];
    for (var j = 0; j < ALL_CODES.length; j++) {
      var code = ALL_CODES[j];
      if (featured[code]) continue;
      var label;
      try { label = dn.of(code) || code; } catch (e) { label = code; }
      rows.push([code, label]);
    }
    rows.sort(function (a, b) { return a[1].localeCompare(b[1], lang); });
    return rows;
  }

  function pushCard(cc, name) {
    var site = siteFor(cc);
    var productPath = location.pathname.split('?')[0];
    // "Somewhere else" (XX) carries no country of its own — fall back to the
    // visitor's geo-detected country (cached by geo-market.js) so the
    // ?country= intent param still punches through Shopify's redirect AND
    // localizes clinks.co to their actual currency. If detection never ran,
    // omit the param (rare; the redirect may then bounce, as before).
    var pushCc = cc;
    if (pushCc === 'XX') {
      try { pushCc = (sessionStorage.getItem('clinks-geo') || '').toUpperCase(); } catch (e) { pushCc = ''; }
    }
    var lead = site === ROW_SITE
      ? TR('push_lead_row', 'Shopping from [country]? Shop on our international store instead.', { country: name })
      : TR('push_lead', 'Shopping from [country]? Shop on our [country] store instead.', { country: name });
    var sub = site === ROW_SITE
      ? T('push_sub_row', 'Prices in your local currency with duties &amp; taxes included. No surprises on delivery.')
      : TR('push_sub', 'Prices in [currency] with duties &amp; taxes included. No surprises on delivery.', { currency: site.cur });
    return (
      '<div class="de-push">' +
      '<p class="de-push__lead">' + lead + '</p>' +
      '<p class="de-push__sub">' + sub + '</p>' +
      // ?country= declares explicit buyer intent — Shopify's server-side
      // country redirection skips the request and sets the localization
      // cookie, so the choice sticks without disabling the (useful) automatic
      // bounce for organic traffic. ck-choice additionally tells the target's
      // geo-market.js to suppress its own "wrong country" modal permanently.
      '<a class="de-push__btn" href="' + site.url + productPath + '?ck-choice=1' +
      (/^[A-Z]{2}$/.test(pushCc) && pushCc !== 'XX' ? '&country=' + pushCc : '') + '">' +
      TR('continue_to', 'Continue to [site] →', { site: site.label }) + '</a>' +
      '</div>'
    );
  }


  function money(cents) {
    if (cents === 0) return T('free', 'FREE');
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  function etaText(eta) {
    return eta.to ? eta.from + ' – ' + eta.to : eta.from;
  }

  function shell(pc) {
    el.innerHTML =
      '<div class="de-au">' +
      '<div class="de-title"><span class="de-title__text">' + T('title', 'Enter your postcode to see delivery options:') + '</span>' +
      '<svg class="de-title__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#a3720e" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 7h10v9H2z"></path><path d="M12 10h4l4 3.5V16h-8z"></path><circle cx="6.5" cy="18" r="1.8"></circle><circle cx="16.5" cy="18" r="1.8"></circle></svg>' +
      '</div>' +
      '<div class="de-head">' + T('delivery_to', 'Delivery to') +
      '<input class="de-pc" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="4" placeholder="' + T('postcode', 'Postcode') + '" aria-label="' + T('postcode', 'Postcode') + '" value="' + (pc || '') + '">' +
      '</div>' +
      '<div class="de-note" hidden><span class="de-note__text"></span> <button type="button" class="de-notyou">' + T('not_you', 'Not you?') + '</button></div>' +
      '<div class="de-hint" hidden></div>' +
      '<div class="de-body" aria-live="polite"></div>' +
      '</div>' +
      '<div class="de-intl" hidden>' +
      '<div class="de-head">' + T('intl_title', 'International delivery') + '</div>' +
      '<label class="de-intl-label" for="de-country">' + T('deliver_to', 'Deliver to') + '</label>' +
      '<select class="de-country" id="de-country"></select>' +
      '<div class="de-intl-eta"></div>' +
      '<div class="de-intl-note">' + T('stay_note', 'Prefer to stay here? You can still check out on this store — international shipping is calculated at checkout.') + '</div>' +
      '</div>' +
      '<button type="button" class="de-toggle" data-mode="au">' + T('toggle_q', 'Shipping internationally?') + ' <u>' + T('toggle_link', 'See international delivery') + '</u></button>';

    var input = el.querySelector('.de-pc');
    input.addEventListener('input', function () {
      var v = input.value.replace(/\D/g, '');
      input.value = v;
      autofilled = null;
      note(false);
      if (v.length === 4 && v !== current) load(v);
    });
    input.addEventListener('focus', function () { input.select(); });

    el.querySelector('.de-notyou').addEventListener('click', function () {
      autofilled = null;
      note(false);
      current = '';
      input.value = '';
      try { localStorage.removeItem(STORE_KEY); } catch (e) {}
      var body = el.querySelector('.de-body');
      if (body) body.innerHTML = '';
      input.focus();
    });

    var select = el.querySelector('.de-country');
    for (var i = 0; i < INTL_COUNTRIES.length; i++) {
      var o = document.createElement('option');
      o.value = INTL_COUNTRIES[i][0];
      o.textContent = (I18N.countries && I18N.countries[INTL_COUNTRIES[i][0]]) || INTL_COUNTRIES[i][1];
      select.appendChild(o);
    }
    var row = restOfWorldOptions();
    if (row) {
      var sep = document.createElement('option');
      sep.disabled = true;
      sep.textContent = '──────────';
      select.appendChild(sep);
      for (var r = 0; r < row.length; r++) {
        var ro = document.createElement('option');
        ro.value = row[r][0];
        ro.textContent = row[r][1];
        select.appendChild(ro);
      }
    } else {
      // no Intl.DisplayNames: keep the old catch-all entry
      var xo = document.createElement('option');
      xo.value = 'XX';
      xo.textContent = (I18N.countries && I18N.countries.XX) || 'Somewhere else';
      select.appendChild(xo);
    }
    select.addEventListener('change', renderIntl);

    var toggle = el.querySelector('.de-toggle');
    toggle.addEventListener('click', function () {
      var toIntl = toggle.getAttribute('data-mode') === 'au';
      el.querySelector('.de-au').hidden = toIntl;
      el.querySelector('.de-intl').hidden = !toIntl;
      toggle.setAttribute('data-mode', toIntl ? 'intl' : 'au');
      toggle.innerHTML = toIntl
        ? '&larr; <u>' + T('back_link', 'Back to Australian delivery') + '</u>'
        : T('toggle_q', 'Shipping internationally?') + ' <u>' + T('toggle_link', 'See international delivery') + '</u>';
      if (toIntl) renderIntl();
    });

    return el.querySelector('.de-body');
  }

  function renderIntl() {
    var select = el.querySelector('.de-country');
    var cc = select.value || 'US';
    var name = select.options[select.selectedIndex].textContent;
    if (cc === 'XX') name = T('overseas', 'overseas');
    el.querySelector('.de-intl-eta').innerHTML = pushCard(cc, name);
  }

  var autofilled = null; // 'detected' | 'restored' | null

  function note(text) {
    var n = el.querySelector('.de-note');
    if (!n) return;
    if (text) { n.querySelector('.de-note__text').textContent = text; n.hidden = false; }
    else { n.hidden = true; }
  }

  function hint(show, text) {
    var h = el.querySelector('.de-hint');
    if (!h) return;
    if (text) h.textContent = text;
    h.hidden = !show;
  }

  function load(pc) {
    var body = el.querySelector('.de-body') || shell(pc);
    body.innerHTML = '<div class="de-loading">' + T('checking', 'Checking delivery times…') + '</div>';
    var qs = '?grams=' + grams + '&price=' + price + '&variant=' + variant + (pc ? '&postcode=' + encodeURIComponent(pc) : '');
    fetch(endpoint + qs)
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { body.innerHTML = ''; hint(true); });
  }

  function render(d) {
    var body = el.querySelector('.de-body');
    if (d.invalid) {
      hint(false);
      body.innerHTML = '<div class="de-error">' + TR('invalid', '[postcode] doesn’t look like an Australian delivery postcode — please double-check it.', { postcode: '<strong>' + d.postcode + '</strong>' }) + '</div>';
      return;
    }
    if (d.needPostcode) {
      body.innerHTML = '';
      hint(false);
      el.querySelector('.de-pc').focus();
      return;
    }
    if (!d.services) { body.innerHTML = ''; hint(false); return; }

    hint(false);
    if (d.detected) { autofilled = 'detected'; }
    if (autofilled === 'detected') { note(T('detected', 'Detected from your location.')); }
    else if (autofilled === 'restored') { note(T('restored', 'Saved from your last visit.')); }
    else { note(false); }
    current = d.postcode;
    try { localStorage.setItem(STORE_KEY, d.postcode); } catch (e) {}
    var input = el.querySelector('.de-pc');
    if (input && input.value !== d.postcode && document.activeElement !== input) input.value = d.postcode;

    var html = '';
    var clock = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 15.5 13.5"/></svg>';
    if (d.dispatch && d.dispatch.same_day && d.dispatch.cutoff_minutes_left != null) {
      var m = d.dispatch.cutoff_minutes_left;
      var t = m >= 60 ? Math.floor(m / 60) + 'h ' + (m % 60) + 'm' : m + 'm';
      html += '<div class="de-cutoff">' + clock + ' ' + TR('order_within', 'Order within [time] for same-day dispatch', { time: '<strong>' + t + '</strong>' }) + '</div>';
    } else if (d.dispatch && d.dispatch.date) {
      html += '<div class="de-dispatch">' + clock + ' ' + TR('dispatches', 'Dispatches [date]', { date: '<strong>' + d.dispatch.date + '</strong>' }) + '</div>';
    }

    html += '<ul class="de-list" role="list">';
    for (var i = 0; i < d.services.length; i++) {
      var s = d.services[i];
      var priceLabel = s.price_cents == null ? TR('from_price', 'from [price]', { price: money(s.from_cents || 0) }) : money(s.price_cents);
      var freeNote = '';
      if (s.code === 'standard' && s.price_cents > 0 && s.free_over_cents) {
        freeNote = '<span class="de-free-note">' + TR('free_over_aud', 'FREE on orders $[amount]+', { amount: Math.round(s.free_over_cents / 100) }) + '</span>';
      }
      html +=
        '<li><span class="de-icon de-icon--' + s.code + '">' + (ICONS[s.code] || '') + '</span>' +
        '<span class="de-info"><span class="de-name">' + s.name + '</span>' +
        '<span class="de-eta">' + TR('est', 'Est. [eta]', { eta: etaText(s.eta) }) + '</span>' + freeNote + '</span>' +
        '<span class="de-price' + (s.price_cents === 0 ? ' de-price--free' : '') + '">' + priceLabel + '</span></li>';
    }
    html += '</ul>';
    body.innerHTML = html;
  }

  /* ---- International markets: three-tier estimate. UPS pricing is postcode-
     sensitive (delivery-area surcharges), so the US gets an editable ZIP with
     the same guessed-then-correctable treatment as the AU postcode. ---- */

  var ZIP_KEY = 'clinks_zip_' + country;
  var currentZip = null;

  function moneyIn(cents, cur) {
    if (cents === 0) return T('free', 'FREE');
    var sym = CUR_SYM[cur] || '';
    var d = cents / 100;
    return sym + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)) + (sym ? '' : ' ' + cur);
  }

  function setIntlHint(text) {
    var h = el.querySelector('.de-hint');
    if (!h) return;
    if (text) { h.textContent = text; h.hidden = false; }
    else { h.hidden = true; }
  }

  function shellIntl(zip) {
    var zipInput = country === 'US'
      ? '<input class="de-pc" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="5" placeholder="' + T('zip', 'ZIP') + '" aria-label="' + T('zip', 'ZIP') + '" value="' + (zip || '') + '">'
      : '';
    var head = zipInput ? T('delivery_to', 'Delivery to') : TR('delivery_to_country', 'Delivery to [country]', { country: countryName });
    el.innerHTML =
      '<div class="de-head">' + head + zipInput + '</div>' +
      '<div class="de-hint" hidden></div>' +
      '<div class="de-body" aria-live="polite"></div>';
    if (zipInput) {
      var input = el.querySelector('.de-pc');
      input.addEventListener('input', function () {
        var v = input.value.replace(/\D/g, '');
        input.value = v;
        if (v.length === 5 && v !== currentZip) loadIntl(v);
      });
      input.addEventListener('focus', function () { input.select(); });
    }
    return el.querySelector('.de-body');
  }

  function loadIntl(zip) {
    var body = el.querySelector('.de-body') || shellIntl(zip);
    body = el.querySelector('.de-body');
    body.innerHTML = '<div class="de-loading">' + T('checking_options', 'Checking delivery options…') + '</div>';
    var qs = '?country=' + country + '&grams=' + grams + '&price=' + price +
      '&currency=' + encodeURIComponent(currency) + '&variant=' + variant +
      (zip ? '&postcode=' + encodeURIComponent(zip) : '');
    fetch(endpoint + qs)
      .then(function (r) { return r.json(); })
      .then(renderIntlLive)
      .catch(function () { body.innerHTML = ''; });
  }

  function renderIntlLive(d) {
    var body = el.querySelector('.de-body');
    if (!d.services || !d.services.length) { body.innerHTML = ''; return; }

    if (country === 'US') {
      currentZip = d.postcode || null;
      if (d.postcode && !d.approx) {
        try { localStorage.setItem(ZIP_KEY, d.postcode); } catch (e) {}
        var input = el.querySelector('.de-pc');
        if (input && input.value !== d.postcode && document.activeElement !== input) input.value = d.postcode;
      }
      if (d.approx) setIntlHint(T('zip_enter', 'Enter your ZIP code — courier pricing varies by area'));
      else if (d.detected) setIntlHint(T('zip_guess', 'We’ve guessed your ZIP — type yours if it’s not right'));
      else setIntlHint(null);
    }

    var html = '';
    var clock = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 15.5 13.5"/></svg>';
    if (d.dispatch && d.dispatch.same_day && d.dispatch.cutoff_minutes_left != null) {
      var m = d.dispatch.cutoff_minutes_left;
      var t = m >= 60 ? Math.floor(m / 60) + 'h ' + (m % 60) + 'm' : m + 'm';
      html += '<div class="de-cutoff">' + clock + ' ' + TR('order_within', 'Order within [time] for same-day dispatch', { time: '<strong>' + t + '</strong>' }) + '</div>';
    } else if (d.dispatch && d.dispatch.date) {
      html += '<div class="de-dispatch">' + clock + ' ' + TR('dispatches', 'Dispatches [date]', { date: '<strong>' + d.dispatch.date + '</strong>' }) + '</div>';
    }

    var ICON_BY_CODE = { standard: ICONS.standard, ems: ICONS.express, ups: ICONS.startrack };
    html += '<ul class="de-list" role="list">';
    for (var i = 0; i < d.services.length; i++) {
      var s = d.services[i];
      var freeNote = '';
      if (s.code === 'standard' && s.price_cents > 0 && s.free_over_cents) {
        // threshold in the market's own currency ("£77", "€86"), as checkout applies it
        freeNote = '<span class="de-free-note">' + TR('free_over', 'FREE on orders over [amount]', { amount: moneyIn(s.free_over_cents, s.currency) }) + '</span>';
      } else if (s.code === 'standard' && s.price_cents > 0 && s.free_over_usd) {
        freeNote = '<span class="de-free-note">' + TR('free_over_usd', 'FREE on orders over $[amount] USD', { amount: s.free_over_usd }) + '</span>';
      }
      var etaText = s.eta && s.eta.from
        ? TR('est', 'Est. [eta]', { eta: s.eta.to ? s.eta.from + ' – ' + s.eta.to : s.eta.from })
        : (s.eta_days ? TR('business_days', 'Est. [n] business days', { n: s.eta_days }) : '');
      html +=
        '<li><span class="de-icon de-icon--' + (s.code === 'ems' ? 'express' : s.code === 'ups' ? 'startrack' : 'standard') + '">' + (ICON_BY_CODE[s.code] || '') + '</span>' +
        '<span class="de-info"><span class="de-name">' + s.name + '</span>' +
        (etaText ? '<span class="de-eta">' + etaText + '</span>' : '') + freeNote + '</span>' +
        '<span class="de-price' + (s.price_cents === 0 ? ' de-price--free' : '') + '">' + moneyIn(s.price_cents, s.currency) + '</span></li>';
    }
    html += '</ul>';
    body.innerHTML = html;
  }

  if (country !== 'AU') {
    // Visitors browsing a market that has its own site are pushed there —
    // that site's pricing has duties & taxes built in. Rates only render when
    // they're already on the right site (or on the myshopify preview host,
    // which keeps staging testable).
    var here = location.hostname.replace(/^www\./, '');
    var target = siteFor(country);
    if (here !== target.host && here.indexOf('myshopify.com') === -1) {
      el.innerHTML =
        '<div class="de-head">' + TR('delivery_to_country', 'Delivery to [country]', { country: countryName }) + '</div>' +
        pushCard(country, countryName);
      return;
    }

    var savedZip = '';
    if (country === 'US') {
      try { savedZip = localStorage.getItem(ZIP_KEY) || ''; } catch (e) {}
      if (!/^\d{5}$/.test(savedZip)) savedZip = '';
    }
    shellIntl(savedZip);
    loadIntl(savedZip);
    return;
  }

  var saved = '';
  try { saved = localStorage.getItem(STORE_KEY) || ''; } catch (e) {}
  // discard saved PO-box-range postcodes from the earlier geo behaviour
  if (/^1\d{3}$/.test(saved)) saved = '';
  if (saved) autofilled = 'restored';
  shell(saved);
  load(saved);
})();
